import { Button, Checkbox, DialogActions, DialogTitle, FormControlLabel, Tab, Tabs } from "@mui/material";
import GTextField from "../libs/textfield/GTextField";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useDialog } from "../libs/dialog/DialogProvider";
import PassApi from "../data/PassApi";
import { useSnackbar } from "../libs/dialog/SnackbarProvider";
import _ from "lodash";
import IPassword from "../shared/Password";

interface ILoginContext {
    isLoggedIn:boolean
    passwords:IPassword[]
    login:Function
}

const LoginContext = createContext<ILoginContext>({isLoggedIn:false, passwords:[], login:()=>{}})
export const useLogin = () => useContext(LoginContext)

function LoginDialog(){
    const email = useRef<any>()
    const password = useRef<any>()
    const confirm = useRef<any>()
    const [tab,setTab] = useState<string>("login")
    const {setSnackbar} = useSnackbar()
    const [busy,setBusy] = useState<boolean>(false)
    const useOffline = useRef<any>()
    const defaultEmail = localStorage.getItem("email") || ""

    useEffect(() => {
        if (!email.current || !password.current) return
        else if (email.current.value) password.current.focus()
        else email.current.focus()
    },[])

    const onLogin = async () => {
        if (!email.current || !password.current || busy) return
        else setBusy(true)

        try {
            localStorage.setItem("email", email.current.value)
            if (tab=="login") await PassApi.i.login(email.current.value, password.current.value, useOffline.current?.checked)
            else await PassApi.i.register(email.current.value, password.current.value)
        }catch(e){
            console.log(e)
            setBusy(false)
            setSnackbar(e)
        }
    }

    const offline = tab=="login" ? <FormControlLabel control={<Checkbox/>} inputRef={useOffline} label="Offline"/> : null
    return <>
        <DialogTitle>
            <Tabs value={tab} onChange={(e,id:string) => setTab(id)}>
                <Tab label="Login" value="login"/>
                <Tab label="Signup" value="signup"/>
            </Tabs>
        </DialogTitle>
        <div className="content">
            <GTextField id="textEmail" placeholder="E-mail" inputRef={email} floatLabel="E-mail" type="email" name="email" defaultValue={defaultEmail}/>
            <GTextField id="textPass" placeholder="Password" inputRef={password} type="password" inputProps={{autoComplete:"hidden","aria-autocomplete":"none"}} onEnter={onLogin} floatLabel="Password"/>
            {tab=="signup" ? <GTextField placeholder="confirm" inputRef={confirm} type="password" inputProps={{autoComplete:"hidden","aria-autocomplete":"none"}} floatLabel="Confirm"/> : null}
            {offline}
        </div>
        <DialogActions>
            <Button variant="contained" onClick={onLogin} disabled={busy}>{tab=="login" ? "Login" : "Create"}</Button>
        </DialogActions>
    </>
}

export default function LoginProvider(props:{children:any}) {
    const [isLoggedIn,setIsLoggedIn] = useState<boolean>(PassApi.i.isLoggedIn)
    const [passwords,setPasswords] = useState<IPassword[]>(PassApi.i.passwords)
    const {dialogs,openDialog,closeDialog} = useDialog()
    const login = () => {
        if (_.findIndex(dialogs, d => d.id=="login")<0) openDialog({id:"login",children:<LoginDialog/>,canClose:()=>false})
    }
    useEffect(() => {
        if (!PassApi.i.isLoggedIn) {
            PassApi.i.on("auth", (isLoggedIn:boolean) => {
                setIsLoggedIn(isLoggedIn)
                if (isLoggedIn) closeDialog()
                else login()
            })
            PassApi.i.resume().catch(login)
        }
        PassApi.i.on("refresh", (passwords:IPassword[]) => setPasswords(passwords.slice(0)))
    },[])
    return <LoginContext.Provider value={{isLoggedIn,passwords,login}}>{props.children}</LoginContext.Provider>
}
